import React, {useEffect} from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
  
    return () => {
      AOS.refresh();
    };
  }, []);
  return (
    <div className="container py-5" style={{margin:"auto"}}>

      {/* History Section */}
      <section className="mt-5 row align-items-center" data-aos="fade-up">
        <h2 className="text-center mb-4 heading">Our History</h2><br/>
        <div className="zoom-container col-md-6">
          <img
            src="/images/pics/history.jpg" /* Replace with actual image path */
            alt="Our History"
            className="img-fluid zoom-image rounded shadow-sm"
          />
        </div>
        <div className="col-md-6">
          <p className="mt-3">
            Established in <strong>2014</strong>, The Civil Lab (formerly known as Snow Fountain Civil Engineering
            Vocational Training Institute - SFCEVTI) was founded to provide cutting-edge training to aspiring civil
            engineers. It is a subsidiary of <strong>Snow Fountain Consultants</strong>, a company with a rich legacy of
            over <strong>25 years</strong> in the civil engineering industry.
          </p>
          <p>
            Leveraging the NABL-accredited laboratories of Snow Fountain Consultants, The Civil Lab ensures students gain
            hands-on training using industry-standard facilities. Our mission has always been to bridge the gap between
            theoretical education and real-world application, creating industry-ready professionals.
          </p>
        </div>
      </section>
        <br/><br/><div style={{backgroundColor:"#ffe607", height:"6px", width:"100%"}} data-aos="fade-up"></div>
      <br/>
      {/* Mission Section */}
      <section className="mt-5 row align-items-center" data-aos="fade-left">
        <h2 className="text-center mb-4 heading">Our Mission</h2><br/>
      
        <div className="col-md-6 order-md-2 zoom-container">
          <img
            src="/images/pics/mission.jpg" /* Replace with actual image path */
            alt="Our Mission"
            className="img-fluid rounded shadow-sm zoom-image"
          />
        </div>
        <div className="col-md-6 order-md-1">
          <p className="mt-3">
            Our mission is to equip civil engineering students with the skills, knowledge, and confidence required to
            excel in the industry. We strive to:
          </p>
          <ul>
            <li>Provide practical training with advanced equipment and tools</li>
            <li>Offer real-world exposure through industry-aligned programs</li>
            <li>Empower students to tackle real-life challenges with confidence and expertise</li>
          </ul>
          <p>
            By combining academic learning with hands-on training, we ensure our students are prepared to contribute
            meaningfully to the civil engineering profession.
          </p>
        </div>
        
      </section>

      {/* Our Team Section */}
        <br/><br/><div style={{backgroundColor:"#ffe607", height:"6px", width:"100%"}} data-aos="fade-up"></div>
      <br/>
      <section className="mt-5 row align-items-center" data-aos="fade-right">
        <h2 className="text-center mb-4 heading">Our Team</h2><br/>
        <div className="col-md-6 zoom-container">
          <img
            src="/images/pics/our-team.JPG" /* Replace with actual image path */
            alt="Our Team"
            className="img-fluid rounded shadow-sm zoom-image"
          />
        </div>
        <div className="col-md-6">
          <section class="about-team">
            <p>
              Our dedicated team of educators and mentors forms the backbone of The Civil Lab. Over the past decade, we have built a team of professionals who bring with them <strong>first-hand experience</strong> from real-world project sites. Each of our trainers has spent years in the field, working on actual civil engineering projects, and has gained unparalleled expertise in using industry-standard tools and technologies.
            </p>
            <p>
              With specialties in areas such as <strong>material testing, surveying, project management, and advanced construction technologies</strong>, our instructors seamlessly bridge the gap between theoretical knowledge and practical application. Their deep understanding of tools and equipment ensures that students receive not just training but the confidence to excel in real-world scenarios.
            </p>
            <p>
              Our trainers are more than just educators—they are <strong>mentors</strong> who are passionate about sharing their knowledge and skills. Through their guidance, countless students have mastered the use of cutting-edge instruments and techniques, preparing them to meet the demands of the civil engineering industry. At The Civil Lab, our team's commitment to excellence and hands-on learning is what empowers students to build successful and rewarding careers.
            </p>
          </section>
        </div>
      </section>
        <br/><br/><div style={{backgroundColor:"#ffe607", height:"6px", width:"100%"}} data-aos="fade-up"></div>
      <br/>
      {/* Campus Location Section */}
     
      <section className="mt-5 row align-items-center" data-aos="fade-up">
        <h2 className="text-center mb-4 heading">Campus</h2><br/>
        <div className="col-md-6 order-md-2 zoom-container">
          <img
            src="/images/pics/institute.PNG" /* Replace with actual image path */
            alt="Campus Location"
            className="img-fluid rounded shadow-sm zoom-image"
          />
        </div>
        <div className="col-md-6 order-md-1">
          <section class="about-campus">
            <p>
              The Civil Lab is located in a serene and accessible area at 
              <strong>[Insert Campus Address Here]</strong>, offering students a peaceful and focused environment for skill development and hands-on training. While the campus is not very large in size, it is thoughtfully designed with sufficient space to accommodate all the necessary tools and facilities required for effective training.
            </p>
            <p>
              Established in 2014 as the <strong>Snow Fountain Civil Engineering Vocational Training Institute</strong>, and now known as The Civil Lab, we have been equipping aspiring civil engineers with practical skills for over a decade. Our long-standing experience and commitment to excellence have made us a trusted name in vocational training.
            </p>
            <p>
              The heart of our campus lies in our <strong>well-equipped laboratories</strong>, where students perform experiments and engage in hands-on training using a comprehensive range of <strong>civil engineering tools and equipment</strong>. From surveying instruments to construction materials testing devices, our labs provide students with a real-world learning experience.
            </p>
            <p>
              For outstation students, we offer a <strong>hostel facility with nutritious meals</strong>, ensuring a comfortable and supportive stay during their training. At The Civil Lab, our focus is on creating a practical, resourceful, and enriching environment that prepares students to excel in the civil engineering industry.
            </p>
          </section>
        </div>
      </section>
      <div className="mt-4 text-center">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3556.8306679646803!2d80.99047377698884!3d26.940582158889587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399959d145787c61%3A0xbb5f4b44974cf68a!2sWoodland%20Garden!5e0!3m2!1sen!2sin!4v1735726019536!5m2!1sen!2sin"
              width="100%"
              height="300"
              title='map'
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
    </div>
  );
};

export default About;
